import { Component, ViewEncapsulation, effect, input } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { Button } from 'primeng/button';
import { Divider } from 'primeng/divider';
import { PanelMenu } from 'primeng/panelmenu';

@Component({
    selector: 'app-sidepanel',
    templateUrl: './sidepanel.component.html',
    styleUrls: ['./sidepanel.component.scss'],
    imports: [RouterLink, Button, Divider, PanelMenu],
    encapsulation: ViewEncapsulation.None,
})
export class SidepanelComponent {

    readonly items = input<MenuItem[]>([{}]);
    readonly actualRoute = input<string>();
    readonly disableRoutes = input<string[]>();

    showSecondaryMenu: boolean = false;

    subitems: MenuItem[] | undefined;
    previousMenuItem: MenuItem = {};
    sectionName: string | undefined;
    selectedItem: MenuItem = {};

    secondaryExpandedClass = 'secondary-menu-expanded';
    secondaryNotExpandedClass = 'secondary-menu-not-expanded';

    constructor(private router: Router) {
        effect(() => {
            const currentItems = this.items();

            if (currentItems && currentItems.length > 0) {
                if (!this.disableRoutes()?.find(route => route === this.actualRoute())) {
                    let actualMenuItem = this.findActualMenuItem(currentItems);

                    // if items() change so the current menu item is not "clicked" twice
                    if (actualMenuItem.parents.filter(p => p.expanded).length == 0) {
                        for (let i = 0; i < actualMenuItem.parents.length; i++) {
                            if (i == 0) {
                                this.primaryMenuItemClick(actualMenuItem.parents[0]);
                            }

                            actualMenuItem.parents[i].expanded = true;
                        }
                    }
                }
            }
        });
    }

    // Click on primary menu item click
    primaryMenuItemClick(menuItem: MenuItem) {
        this.selectedItem = menuItem;

        if (!this.previousMenuItem) {
            this.previousMenuItem = menuItem;
        }

        if (this.previousMenuItem !== menuItem && menuItem.items) {
            this.showSecondaryMenu = true;
        }
        else if (this.previousMenuItem === menuItem && menuItem.items) {
            this.showSecondaryMenu = !this.showSecondaryMenu;
        }
        else {
            this.showSecondaryMenu = false;
        }

        this.subitems = menuItem.items;
        this.previousMenuItem = menuItem;
        this.sectionName = menuItem.label?.toUpperCase();

        // setting body class based on secondary menu expansion
        if (this.showSecondaryMenu) {
            document.body.classList.add(this.secondaryExpandedClass);
            document.body.classList.remove(this.secondaryNotExpandedClass);
        }
        else {
            document.body.classList.add(this.secondaryNotExpandedClass);
            document.body.classList.remove(this.secondaryExpandedClass);
        }
    }

    // Find parent of actual menu item by route
    findActualMenuItem(items: MenuItem[]): MenuItemWithParents {
        let menuItemWithParent: MenuItemWithParents = { parents: [] };

        const actualRoute = this.actualRoute();
        if (actualRoute) {
            for (let item of items) {
                if (item.routerLink == actualRoute) {
                    menuItemWithParent.item = item;
                    break;
                } else {
                    if (item.items) {
                        let menuItem = this.findActualMenuItem(item.items);

                        if (menuItem.item) {
                            menuItemWithParent.parents.push(item);
                            menuItemWithParent.parents = menuItemWithParent.parents.concat(menuItem.parents);
                            menuItemWithParent.item = menuItem.item;
                            break;
                        }
                    }
                }
            }
        }
        return menuItemWithParent;
    }

    isActivatedRoute(item: MenuItem) {
        return !this.showSecondaryMenu && item.routerLink === this.router.url && !item.items;
    }

    getMenuButtonStyleClass(item: any) {
        let base = 'menu-button h-12 bg-black-dark text-muted-color border-0 text-left justify-start';
        base = `${base} ${this.showSecondaryMenu ? 'w-12' : 'w-44'} ${((this.showSecondaryMenu && this.selectedItem === item) || this.isActivatedRoute(item)) ? 'menu-button-selected' : ''}`;
        return base;
    }

}

interface MenuItemWithParents {
    item?: MenuItem;
    parents: MenuItem[];
}